const LINKEDIN_URL_REGEX =
  /^(https?:\/\/)?([\w-]+\.)*linkedin\.com\/(in|pub|company)\//i

export function isLinkedinProfileUrl(value: string): boolean {
  return LINKEDIN_URL_REGEX.test(value)
}

export function validateNameOrLinkedinUrl(value: string): boolean {
  if (value && (value.startsWith("http://") || value.startsWith("https://"))) {
    return validateLinkedinUrl(value)
  }
  return true
}

export function validateLinkedinUrl(value: string): boolean {
  if (value && (value.startsWith("http://") || value.startsWith("https://"))) {
    const { hostname, pathname } = new URL(value)
    if (hostname !== "linkedin.com" && hostname !== "www.linkedin.com")
      return false
    return /^\/(in|company)\/[^/]+/.test(pathname)
  }
  return false
}
